export const BS_IMAGE_FIGURE_TYPE = 'bs-image-figure';
export const BS_IMAGE_IMG_TYPE = 'bs-image';
export const BS_IMAGE_CAPTION_TYPE = 'bs-image-caption';

export const BS_IMAGE_FIGURE_CLASS = 'sio-image-figure';
export const BS_IMAGE_CAPTION_CLASS = 'sio-image-caption';

export const BS_IMAGE_PLACEHOLDER_SRC =
    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImZpbGw6IHJnYmEoMCwwLDAsMC4xNSk7IHRyYW5zZm9ybTogc2NhbGUoMC43NSkiPgogICAgICAgIDxwYXRoIGQ9Ik04LjUgMTMuNWwyLjUgMyAzLjUtNC41IDQuNSA2SDVtMTYgMVY1YTIgMiAwIDAgMC0yLTJINWMtMS4xIDAtMiAuOS0yIDJ2MTRjMCAxLjEuOSAyIDIgMmgxNGMxLjEgMCAyLS45IDItMnoiPjwvcGF0aD4KICAgICAgPC9zdmc+';
